import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import initialState from './state'

export default {
	state: { ...initialState },
	mutations,
	actions,
	getters,
}
